import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Loader2, Users, AlertTriangle } from "lucide-react";
import { SiteNav } from "@/components/SiteNav";
import { api, formatError, fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ROLE_INFO } from "@/pages/Team";

export default function Join() {
  const { token } = useParams();
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [inv, setInv] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/org/join/${token}`).then((r) => setInv(r.data)).catch((e) => setError(formatError(e))); }, [token]);
  const accept = async () => {
    setBusy(true);
    setError("");
    try {
      await api.post(`/org/join/${token}`);
      await refresh();
      nav("/app/team");
    } catch (e) {
      setError(formatError(e));
      setBusy(false);
    }
  };
  const next = encodeURIComponent(`/join/${token}`);
  return (
    <div className="min-h-screen"><SiteNav />
      <div className="max-w-lg mx-auto px-6 py-20" data-testid="join-page">
        <Users size={36} className="text-emerald-600" />
        {!inv && !error && <Loader2 className="animate-spin text-emerald-600 mt-6" />}
        {inv && (
          <>
            <h1 className="font-display text-3xl font-bold mt-5" data-testid="join-title">Join {inv.org_name}</h1>
            <p className="text-slate-600 dark:text-slate-300 mt-3">{inv.invited_by_name} invited <span className="font-mono">{inv.email_masked}</span> as a <span className="font-semibold" data-testid="join-role">{inv.role}</span>.</p>
            <p className="text-xs text-slate-500 mt-1">{ROLE_INFO[inv.role]} · expires {fmtDate(inv.expires_at)}</p>
            {user ? (
              <button data-testid="join-accept-btn" onClick={accept} disabled={busy} className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-emerald-600 text-white font-semibold hover:bg-emerald-500 transition-colors disabled:opacity-60">
                {busy && <Loader2 size={16} className="animate-spin" />} Accept as {user.email}
              </button>
            ) : user === false && (
              <div className="mt-8 flex flex-wrap gap-3">
                <Link to={`/register?next=${next}`} data-testid="join-register-btn" className="px-5 py-2.5 rounded-full bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-500">Create account</Link>
                <Link to={`/login?next=${next}`} data-testid="join-login-btn" className="px-5 py-2.5 rounded-full border border-slate-300 dark:border-slate-700 text-sm font-semibold hover:bg-slate-100 dark:hover:bg-slate-800">Sign in</Link>
              </div>
            )}
          </>
        )}
        {error && <p data-testid="join-error" className="mt-6 text-sm text-red-600 flex gap-2"><AlertTriangle size={16} className="shrink-0" /> {error}</p>}
      </div>
    </div>
  );
}
